import { useEffect } from 'react';
import { toast } from 'react-toastify';
import {
  useListMethodsQuery,
  useListSigningAppointmentsQuery,
  useListStatusesQuery,
  useListTypesQuery,
} from '../../../API/order/signingAppointment/SigningAppointmentAPI';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../types/shared/UUID';
import { useSelectCurrentOrder } from '../../../selectors/order/selectCurrentOrder';

export const useSigningAppointmentErrorToasts = () => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const { fetchError: orderDetailsIsError } = useSelectCurrentOrder();
  const { isError: signingTypesIsError } = useListTypesQuery();
  const { isError: signingMethodsIsError } = useListMethodsQuery();
  const { isError: signingStatusesIsError } = useListStatusesQuery();
  const { isError: signingAppointmentsIsError } = useListSigningAppointmentsQuery({
    orderId,
  });
  useEffect(() => {
    [
      { isError: !!orderDetailsIsError, message: 'Error fetching order' },
      { isError: signingAppointmentsIsError, message: 'Error fetching Signing Appointments' },
      { isError: signingStatusesIsError, message: 'Error fetching Signing Statuses' },
      { isError: signingTypesIsError, message: 'Error fetching Signing Types' },
      { isError: signingMethodsIsError, message: 'Error fetching Signing Methods' },
    ].forEach(({ isError, message }) => {
      if (isError) {
        toast.error(message);
      }
    });
  }, [
    orderDetailsIsError,
    signingAppointmentsIsError,
    signingStatusesIsError,
    signingTypesIsError,
    signingMethodsIsError,
  ]);
};
